<template lang="pug">
section.tabela-cadastro-territorios
    h3.tabela-cadastro-territorios__title Lista de territorios registrados

    el-table(
        :data='territorios'
        style='width: 100%'
        @selection-change='handleSelectionChange'
    )
        el-table-column(
            v-if='removendo'
            type='selection'
            width='45'
            align='center'
        )

        el-table-column(
            prop='nome'
            :label='$t("mensagens.territorio.territorioAr.fazenda")'
            min-width='180'
        )

        el-table-column(prop='renspa' label='RENSPA' width='160')
            template(slot-scope='scope')
                span {{ formatRenspa(scope.row.renspa) }}

        el-table-column(
            prop='provincia'
            :label='$t("mensagens.territorio.labels.provincia")'
            width='210'
        )

        el-table-column(:label='$t("mensagens.territorio.territorioAr.cultivo")' min-width='200')
            template(slot-scope='scope')
                span {{ formatCultivos(scope.row.informacoesAgricolas) }}

        el-table-column(label='Área (ha)' width='150' align='right')
            template(slot-scope='scope')
                span {{ scope.row.totalAreaHa }} ha

        el-table-column(:label='$t("mensagens.territorio.territorioAr.persona.titulo")' min-width='200')
            template(slot-scope='scope')
                .produtores
                    el-tag(
                        v-for='(rep, index) in scope.row.representantes'
                        :key='index'
                        size='mini'
                        type='info'
                        class='produtor-tag'
                    ) {{ rep.nomeRazaoSocial }}
                    span(v-if='!scope.row.representantes || scope.row.representantes.length === 0') —

        el-table-column(label='Origen' width='100' align='center')
            template(slot-scope='scope')
                el-tag(
                    :type='scope.row.origem === "Manual" ? "success" : "warning"'
                    size='mini'
                    effect='plain'
                    class='origem-tag'
                ) {{ scope.row.origem === 'Manual' ? 'Manual' : 'Lote' }}

        el-table-column(label='Estado' width='120' align='center')
            template(slot-scope='scope')
                el-tag(
                    v-if='scope.row.status'
                    :type='statusTagType(scope.row.status)'
                    size='mini'
                    effect='plain'
                ) {{ statusLabel(scope.row.status) }}

        el-table-column(label='Acciones' width='90' align='center')
            template(slot-scope='scope')
                el-button(
                    v-if='scope.row._preview'
                    type='text'
                    icon='el-icon-edit'
                    @click='$emit("editarTerritorio", scope.row)'
                )

        template(slot='empty')
            el-empty(description='Nenhum territorio añadido')
</template>

<script>
export default {
    name: 'TabelaCadastroTerritorio',
    props: {
        territorios: {
            type: Array,
            required: true
        },
        removendo: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            territoriosSelecionados: []
        };
    },
    computed: {
        territoriosSemErro() {
            return this.territorios.filter(t => t.status !== 'ERRO' && t.status !== 'SOBREPOSTO');
        }
    },
    methods: {
        handleSelectionChange(selecionados) {
            this.territoriosSelecionados = selecionados;
            this.$emit('territoriosSelecionados', selecionados);
        },

        formatRenspa(renspa) {
            if (!renspa) return '—';
            const digits = renspa.replace(/\D/g, '');

            if (digits.length !== 13) return renspa;

            return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 6)}.${digits.slice(6, 11)}/${digits.slice(11, 13)}`;
        },

        formatCultivos(informacoesAgricolas) {
            if (!informacoesAgricolas || informacoesAgricolas.length === 0) return '—';

            return informacoesAgricolas
                .map(item => item.nome)
                .filter(Boolean)
                .join(', ');
        },

        statusTagType(status) {
            if (status === 'VALIDO') return 'success';
            if (status === 'SOBREPOSTO') return 'warning';
            if (status === 'ERRO') return 'danger';
            return 'info';
        },

        statusLabel(status) {
            if (status === 'VALIDO') return 'Válido';
            if (status === 'SOBREPOSTO') return 'Solapado';
            if (status === 'ERRO') return 'Error';
            return status;
        }
    }
};
</script>

<style lang="scss" scoped>
.tabela-cadastro-territorios {
    &__title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 16px;
    }

    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;
    }

    .produtores {
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
    }

    .produtor-tag {
        max-width: 160px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 15px;
    }

    .produtor-tag,
    .origem-tag {
        height: auto !important;
        line-height: normal !important;
        padding: 6px 12px !important;
    }
}
</style>
